<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FRj3zp/tc-custom/9781571318299.jpg?1704453930348" alt="This image is the cover for the book American Brat"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">American Brat
      </h1>
      <p class="bookDescription body article font2">
        <b>A sheltered Pakistani girl is sent to America by her parents, with unexpected results: “Entertaining, often hilarious . . . Not just another immigrant’s tale.” —<i>Publishers Weekly</i></b><br/><br/>Feroza Ginwalla, a pampered, protected sixteen-year-old Pakistani girl, is sent to America by her parents, who are alarmed by the fundamentalism overtaking Pakistan—and influencing their daughter. Hoping that a few months with her uncle, an MIT grad student, will soften the girl’s rigid thinking, they get more than they bargained for: Feroza, enthralled by American culture and her new freedom, insists on staying. <br/><br/>A bargain is struck, allowing Feroza to attend college with the understanding that she will return home and marry well. As a student in a small western town, Feroza finds her perceptions of America, her homeland, and herself beginning to alter. When she falls in love with a Jewish American, her family is aghast. Feroza realizes just how far she has come—and wonders how much further she can go—in a delightful, remarkably funny coming-of-age novel that offers an acute portrayal of America as seen through the eyes of a perceptive young immigrant.<br/><br/>“Humorous and affecting.” —<i>Library Journal</i><br/><br/>“Exceptional.” —<i>Los Angeles Times</i><br/><br/>“Her characters [are] painted so vividly you can almost hear them bickering.” —<i>The New York Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bapsi Sidhwa
      </h2>
      
      <p class="authorDescription body article"> Born in Karachi and raised in Lahore, Pakistan, Bapsi Sidhwa has been widely celebrated as the finest novelist produced by her country. Sidhwa is the author of five novels: <I>The Pakistani Bride</I>, <I>Crow Eaters</I>, <I>An American Brat</I>, <I>Cracking India </I>(which was made into the award-winning film <I>Earth</I> by Indian director Deepa Mehta in 1999, and was named by Modern Library one of the best books in English published since 1950), and, most recently, <I>Water</I> (which was based on Deepa Mehta&rsquo;s screenplay for the film of the same name). Her work has been published in ten countries and has been translated into several languages. Among her many honors, Sidhwa has received the Bunting Fellowship at Radcliffe/Harvard, the Lila Wallace-Reader&rsquo;s Digest Writer&rsquo;s Award, a National Endowment for the Arts Fellowship, and the Sitara-i-Imtiaz, Pakistan&rsquo;s highest honor in the arts. She also served, at Prime Minister Benazir Bhutto&rsquo;s request, on an Advisory Committee on Women&rsquo;s Development in Pakistan. Sidhwa now resides in Houston. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Milkweed Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4954714e